import { WifiStrength3AlertIcon } from './WifiStrength3AlertIcon';

/**
 * author: Simran
 * id 780617FD-FBFA-4F88-98CA-2DEA43409312
 * name wifi-strength-3-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-3-alert.svg
 * tags
 * - Alert / Error 
 */
export const WifiStrength3WarningIcon = WifiStrength3AlertIcon;
export default WifiStrength3WarningIcon